<template>
	<row-object-page name="event_edit" :oref="oref" v-model="event" :force-info="true" :parent-errors="extraErrors" ref="rowObject"></row-object-page>
</template>

<script setup lang="ts">
import {ref, computed, provide, reactive} from "vue";
import RowObjectPage from "@/pages/row-object/RowObjectPage.vue";
import {objectRef, RowObjectInit, RowObjectRef, RowObjectType, SrcType} from "@t/meta/SourceType.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import {PRINTS_GROUP_ID, SideMenu, TOOLS_GROUP_ID} from "@t/ui/Menu.ts";
import type { Event} from "@t/event/Event.ts";
import {connectEventBus, injectEnv} from "@fd/Environment.ts";
import {ErrorMap} from "@fd/PartInjectKeys.ts";
import {hasAccess, isSecured} from "@t/security/ObjectAccess.ts";
import {useVirtualRoute} from "@/router/virtual/VirtualRouter.ts";
import {CREATE, EDIT, REPLACE_INIT_WITH_EDIT} from "@/pages/row-object/RowObjectEvents.ts";

const ns = useNavigationStore();
const env = injectEnv();
const bus = connectEventBus("EventPage");

const event = ref<Event>(null);
const rowObject = ref<InstanceType<typeof RowObjectPage> | null>(null);
const extraErrors = reactive<ErrorMap>([]);
const route = useVirtualRoute();
const oref = objectRef(route, SrcType.EVENT);

ns.listenForStackerUpdates(bus, oref, () => env.msg('title.createEvent'),
	"/editEvent.do", () => event.value.subject, () => event.value.id);

ns.defineMenu((mb) => {
	if (event.value?.id) {
		mb.pageNamed("event_edit");
		mb.inGroup(TOOLS_GROUP_ID, (gb) => {
			gb.navItem("seeThis", "see.do?id="+event.value?.id+"&type="+SrcType.EVENT, "menu.seeThis", "eye-eyebrow");
			if (hasAccess(event.value, "delete")) {
				gb.navItem("moveEvent", "planEvent.do?parentEvent="+event.value.id, "menu.moveEvent", "replan");
				gb.confirmDelete(gb.navItem("deleteEvent", "deleteEvent.do?id="+event.value.id, "menu.deleteEvent", "trash"), "menu.deleteEvent.confirm");
			}
			gb.executeItem("invite", () => { prepareInvitation(); }, "menu.sendInvitation", "send");
		});
		mb.inGroup(PRINTS_GROUP_ID, (gb) => {
			gb.navItem("outputParams", "outputParams.do?descriptor=2&pk=" + event.value.id + "&section="+ns.activeSection, "title.printEvent", "printer");
		});
	}
});

async function prepareInvitation() {
	const ns = useNavigationStore();
	let ep = "api/events/"+event.value?.id+"/invitation";
	const resp = await env.net.fetch(ep, "POST", {});
	return resp.ok;
}
</script>

<style>

</style>